import { Component, OnInit } from '@angular/core';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { FormCommonApiService } from '../../../../../service/api/formcommon-api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseForm } from '../../../../base-form';
import {
    stack,
    build,
} from '../../../../../common/classes/request-builder';
import { environment } from '../../../../../../environments/environment';
import { ClientesApiService } from '../../../../../service/api/clientes-api.service';
import { AnalisisModel } from '../../../../../models/analisis/analisis.model';
import { AnalisisApiService } from '../../../../../service/api/analisis-api.service';
import { HttpClient } from '@angular/common/http';

import { SiexApiService } from 'src/app/service/api/siex-api.service';
import { AnalisisEnvironmentDefinition } from '../environment-variables';
import { AnalisisFormDefinition } from './fields/formfields';
import { EventPhase, FormPhase, ReactiveFormRequestCoordinator } from '@fitogest/reactive-form-builder/form-request';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ComunidadesRegantesModel } from 'src/app/models/analisis/comunidadesRegantes.model';
import { ClienteModel } from 'src/app/models/cliente.model';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { ReactiveFormChangedField, ReactiveFormValue, FormType } from '@fitogest/reactive-form-builder/interfaces';

@Component({
    selector: 'app-analisis-form',
    standalone: false,
    templateUrl: './analisis-form.component.html',
    styleUrls: ['./analisis-form.component.scss'],
})
export class AnalisisFormComponent extends BaseForm<AnalisisModel> implements OnInit {
    public comunidadForm: FormGroup;

    /** Reactive form definition bound to the template */
    public form!: AnalisisFormDefinition;
    
    /** Form request engine (phase-based hooks) */
    public formRequest = new ReactiveFormRequestCoordinator<AnalisisModel>;
    
    public env: AnalisisEnvironmentDefinition = new AnalisisEnvironmentDefinition();
    public enableFormChanges = true;

    public override model = {} as AnalisisModel;
    public type: FormType = this.getType();
    public id_finca = '';

    // public analisisProximo: any;
    public programarSiguiente = false;

    public analisisImg: string | ArrayBuffer | null | undefined = '';

    public showExtraFields = false;
  
    public tipoSuperficieParcelas: string = environment.features.hasSuperficieCultivada
        ? 'S.\xa0C.'
        : 'S.\xa0Sigpac';
    public oldSector = 0;
  

    constructor(
        public override route: ActivatedRoute,
        public override router: Router,
        public fincasApi: FincasApiService,
        public clientesApi: ClientesApiService,
        public formApi: FormCommonApiService,
        public override dashboard: DashboardService,
        public siexApi: SiexApiService,
        public analisisApi: AnalisisApiService,
        public http: HttpClient,
        private readonly formBuilder: FormBuilder
    ) {
        super(
            route,
            router,
            dashboard,
            analisisApi.analisis.PUT,
            analisisApi.analisis.POST,
            'analisis',
            'Editar Recordatorio de Análisis',
            'Crear Recordatorio de Análisis'
        );
        this.comunidadForm = this.formBuilder.group({
            nombre: ['', [Validators.required, Validators.maxLength(100)]],
            id_usuario: [StorageManager.getUser().id],
            id_cliente: [StorageManager.getClient()?.id ?? ''],
        });
    }

    ngOnInit() {
        this.resetExternalDropdowns();
        this.form = new AnalisisFormDefinition(
            this.getType(),
            this.getModel() as unknown as Record<string,string>,
            null
        );
        this.initFormData();
        setTimeout(() => {
            this.expandFormRequest();
        }, 9000);

        this.formRequest.executePhase(FormPhase.LOAD);        
        this.softInit(this.getType());

        this.analisisApi.analisis.POST.response(() => {
            const modelToSave = this.form?.model;
            if (modelToSave?.fecha) {
                localStorage.setItem('analisis_temp', JSON.stringify([modelToSave]));
            }
        });
        this.analisisApi.analisis.PUT.response(() => {
            const modelToSave = this.form?.model;
            if (modelToSave?.fecha) {
                localStorage.setItem('analisis_temp', JSON.stringify([modelToSave]));
            }
        });
    }


    public formChanges(formModel: ReactiveFormValue<AnalisisModel>, lastChangedFieldName: ReactiveFormChangedField<AnalisisModel>): void {
        this.form.model = formModel;
        this.form.tag = lastChangedFieldName;
    }

    private ensureSelectedClientOption(): void {
        const selectedClient = StorageManager.getClient();
        const selectedClientId = String(selectedClient?.id ?? '').trim();

        if (!selectedClient || selectedClientId === '') {
            return;
        }

        const exists = (this.form.lists.clientes.values ?? [])
            .some((item) => String((item.value as ClienteModel | null)?.id ?? '').trim() === selectedClientId);

        if (exists) {
            return;
        }

        const option = {
            label: selectedClient.nombre || selectedClient.razon_social || selectedClientId,
            value: selectedClient,
        };

        this.form.lists.clientes.values = [option, ...(this.form.lists.clientes.values ?? [])];
        this.form.lists.clientes.filtered = [option, ...(this.form.lists.clientes.filtered ?? [])];
    }

    private syncSelectedClientControl(): void {
        const selectedClientId = String(StorageManager.getClient()?.id ?? '').trim();
        const control = this.formBuilderRef?.model?.get('id_cliente');

        if (!control || selectedClientId === '') {
            return;
        }

        const currentValue = control.value;
        const hasValue = Array.isArray(currentValue)
            ? currentValue.length > 0
            : String(currentValue ?? '').trim() !== '';

        if (hasValue) {
            return;
        }

        const controlValue = this.form.env.applicationType === 'cropgest' ? [selectedClientId] : selectedClientId;

        control.patchValue(controlValue, { emitEvent: false });
        control.markAsPristine();
    }

    public saveNewOption(): void {
        if (this.comunidadForm.invalid) {
            this.comunidadForm.markAllAsTouched();
            return;
        }

        const endpoint: string = `${this.form.env.serverUrl}/ws/index.php?p1=generic&p2=comunidades_regantes`;
        const payload: ComunidadesRegantesModel = this.comunidadForm.getRawValue();

        this.http.post<ComunidadesRegantesModel>(endpoint, payload)
            .subscribe({
            next: () => {
                this.comunidadForm.reset({
                nombre: '',
                id_usuario: StorageManager.getUser().id,
                id_cliente: StorageManager.getClient()?.id ?? '',
                });

                this.form.openDialog = false;

                stack([
                build(this.analisisApi.comunidadesRegantes.GET, this.form.lists.comunidadesRegantes, 'nombre'),
                ]).then(() => {
                const newName = payload.nombre;
                const match = this.form.lists.comunidadesRegantes.filtered
                    .find((item: any) => item.value && item.value.nombre === newName);

                if (match) {
                    const control = this.formBuilderRef?.model?.get('id_comunidad_regantes');

                    if (control) {
                    control.patchValue(match.value?.id, { emitEvent: false });
                    control.markAsPristine();
                    }
                }

                this.dropdownLoadTrigger.next();
                return;
                }).catch((e: unknown) => {
                console.error('Error reloading comunidades_regantes:', e);
                });
            },
            error: (error: unknown) => {
                console.error('Error creating comunidad_regantes:', error);
            },
            });
        }


    changeSectores(): Promise<void> {
        if (!this.form.env.showAnalisisSectorParcelas) {
            return Promise.resolve();
        }

        const builds = [
            build(this.fincasApi.sectoresGET, this.form.lists.sectores, 'nombre', true),
            build(this.fincasApi.parcelasGET, this.form.lists.lista_parcelas, 'nombre', true),
        ];

        return stack(builds).then(() => {
            return;
        }).catch(e => {
            console.log('catch en changeSectores: ' + e);
        }) as Promise<void>;
    }

    private expandFormRequest() {
        const builds = [
            build(this.clientesApi.clientesGET, this.form.lists.clientes, 'nombre'),
            build(this.fincasApi.fincasGET, this.form.lists.fincas, 'nombre', true)
        ];

        this.formRequest.addEvent(FormPhase.LOAD, EventPhase.BEFORE, (resolve) => {
            stack(builds).then(() => {          
                resolve(true);
                return;
            }).catch (e => {
                console.log('catch en getPosition: ' + e);
            }
            );
        });
    }

    private initFormData() {
        const builds = [
            build(this.clientesApi.clientesGET, this.form.lists.clientes, 'nombre', true),
            build(this.fincasApi.fincasGET, this.form.lists.fincas, 'nombre', true),
            build(this.analisisApi.comunidadesRegantes.GET, this.form.lists.comunidadesRegantes, 'nombre'),
        ];

        if (this.form.env.showAnalisisParcelas) {
            builds.push(
                build(this.fincasApi.parcelasGET, this.form.lists.parcelas, 'nombre', true)
            );
        }

        stack(builds).then(() => {
            this.ensureSelectedClientOption();
            this.syncSelectedClientControl();

            return this.changeSectores();
        }).then(() => {
            this.ensureSelectedClientOption();
            this.syncSelectedClientControl();
            this.finalizeExternalDropdowns();
            this.dropdownLoadTrigger.next();
            return;
        }).catch(e => {
            console.log('catch en initFormData: ' + e);
        });
    }
}